import { animate, AnimationTriggerMetadata, style, transition, trigger } from "@angular/animations";

export function fadeIn(timingIn: number, timingOut: number, height: boolean = false): AnimationTriggerMetadata  {
  return trigger('fadeIn', [
    transition(':enter', [
      style(height ? { opacity: 0 , height: 0, } : { opacity: 0, }),
      animate(timingIn, style(height ? { opacity: 1, height: 1 } : { opacity: 1, })),
    ]),
    /* Część do znikania zdjęcia teoretycznie
    transition(':leave', [
      animate( timingOut, style(height ? { opacity: 0, height: 0, } : { opacity: 0, })),
    ])*/
  ]);
}